module.exports = __webpack_public_path__ + "static/africa-internet-f6e04e5bf580fd84c8a99ccdc13c019e.png";